export const BUILD_HEADER_CHANGE_IMAGE_SOURCE = 'BUILD_HEADER_CHANGE_IMAGE_SOURCE';
export const BUILD_HEADER_CHANGE_IMAGE_SUBMIT_STATUS = 'BUILD_HEADER_CHANGE_IMAGE_SUBMIT_STATUS';
export const BUILD_HEADER_CHANGE_PREVIEW_IMAGE_SIZE = 'BUILD_HEADER_CHANGE_PREVIEW_IMAGE_SIZE';
export const RESET_IMAGE_IMPORT_FORM = 'RESET_IMAGE_IMPORT_FORM';
